import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M8.625 7.625h-5.25m5.25-3.25h-5.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);